import {Exclude, Expose, Type} from "class-transformer";
import {AbstractApiModel} from "./abstract.api.model";
import {BugReportAttachmentApiModel} from "./bug-report-attachment.api-model";
import {UserApiModel} from "./user.api-model";
import {BugReportErrorContext} from "./bug-report-error-context.model";

@Exclude()
export class BugReportApiModel extends AbstractApiModel {
  @Expose() public id: string;
  @Expose() public code: string | null;
  @Expose() public topic: string;
  @Expose() public content: string;
  @Expose() public errorContext: BugReportErrorContext | null = null;
  @Expose() @Type(() => BugReportAttachmentApiModel) public attachments: (BugReportAttachmentApiModel | string)[] = [];
  @Expose() @Type(() => UserApiModel) public reportedBy: UserApiModel | string;
  @Expose() public reportedByName: string | null;
  @Expose() public archivedAt: string | null;
  @Expose() public createdAt: Date;
  @Expose() public updatedAt: Date;
}
